import React from 'react';
import { MdOutlineCancel } from 'react-icons/md';

const Modal = ({ show, title, children, onClose, size = 'md' }) => {
	if (!show) return null;

	// Define modal size based on size prop
	const getSizeClasses = () => {
		switch (size) {
			case 'xs':
				return 'w-11/12 md:w-1/4';
			case 'sm':
				return 'w-11/12 md:w-1/3';
			case 'md':
				return 'w-11/12 md:w-1/2';
			case 'lg':
				return 'w-11/12 md:w-2/3';
			case 'xl':
				return 'w-11/12 md:w-3/4';
			case 'full':
				return 'w-full h-full';
			default:
				return 'w-11/12 md:w-1/2';
		}
	};

	return (
		<div
			className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center px-4"
			onClick={onClose} // Close on backdrop click
		>
			<div
				className={`bg-white dark:bg-[#42464D] rounded-lg shadow-lg max-h-[90vh] overflow-y-auto relative ${getSizeClasses()}`}
				onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
			>
				{/* Header */}
				<div className="flex justify-between items-center px-4 py-3 border-b border-gray-200">
					<h2 className="text-lg font-semibold dark:text-gray-200">{title}</h2>
					<button
						onClick={onClose}
						className="text-xl text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-100"
					>
						<MdOutlineCancel size={24} />
					</button>
				</div>

				{/* Body */}
				<div className="px-4 py-4">{children}</div>
			</div>
		</div>
	);
};

export default Modal;